import { ListChecks } from "@phosphor-icons/react";

// performance (high=true/low) × values (high=true/low)
export function calDisposition(perf, values) {
  if (perf && values) return "Promote / Stretch";
  if (!perf && values) return "Coach / Develop";
  if (perf && !values) return "Confront / Realign";
  return "Manage Out";
}

export const DISPOSITIONS = ["Promote / Stretch", "Coach / Develop", "Confront / Realign", "Manage Out"];

const QUADRANTS = [
  { perf: true, values: true, title: "Promote / Stretch", sub: "High Performance · High Values", head: "bg-emerald-50 border-emerald-200 text-emerald-700" },
  { perf: true, values: false, title: "Confront / Realign", sub: "High Performance · Low Values", head: "bg-amber-50 border-amber-200 text-amber-700" },
  { perf: false, values: true, title: "Coach / Develop", sub: "Low Performance · High Values", head: "bg-blue-50 border-blue-200 text-blue-700" },
  { perf: false, values: false, title: "Manage Out", sub: "Low Performance · Low Values", head: "bg-red-50 border-red-200 text-red-700" },
];

export default function CalibrationBlueprint({ doc }) {
  const members = (doc.payload?.members || []).filter((m) => m.name?.trim());
  const inQuadrant = (q) => members.filter((m) => !!m.performance === q.perf && !!m.values === q.values);

  return (
    <>
      {doc.payload?.context && <p className="mb-6 text-sm text-slate-500 max-w-2xl">{doc.payload.context}</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="calibration-grid">
        {QUADRANTS.map((q) => {
          const items = inQuadrant(q);
          return (
            <div key={q.title} data-testid={`cal-quadrant-${q.title.toLowerCase().replace(/[\s/]+/g, "-")}`} className="border border-slate-200 rounded-sm bg-white overflow-hidden">
              <div className={`px-4 py-3 border-b ${q.head}`}>
                <p className="font-mono text-sm font-bold uppercase tracking-wide">{q.title}</p>
                <p className="text-xs opacity-80">{q.sub}</p>
              </div>
              <div className="p-4 min-h-[120px]">
                {items.length === 0 ? <p className="text-sm text-slate-300">— No one placed here —</p> : (
                  <ul className="space-y-2">
                    {items.map((m) => (
                      <li key={m.id} className="flex items-start gap-2 text-sm text-slate-800">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0" />
                        <span><span className="font-medium">{m.name}</span>{m.role && <span className="text-slate-400"> · {m.role}</span>}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8">
        <div className="flex items-center gap-2 mb-3">
          <ListChecks size={18} weight="duotone" className="text-emerald-600" />
          <h2 className="font-mono text-sm font-bold uppercase tracking-[0.1em] text-slate-700">Development Actions</h2>
        </div>
        {members.length === 0 ? (
          <p className="text-sm text-slate-400 border border-dashed border-slate-300 rounded-sm p-4 text-center">No team members.</p>
        ) : (
          <div className="bg-white border border-slate-200 rounded-sm overflow-hidden" data-testid="calibration-actions-table">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
                  <th className="px-5 py-3 font-semibold">Member</th>
                  <th className="px-5 py-3 font-semibold">Disposition</th>
                  <th className="px-5 py-3 font-semibold">Next Action</th>
                  <th className="px-5 py-3 font-semibold">Owner</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {members.map((m) => (
                  <tr key={m.id}>
                    <td className="px-5 py-3.5 text-sm font-medium text-slate-900">{m.name}{m.role && <span className="block text-xs font-normal text-slate-400">{m.role}</span>}</td>
                    <td className="px-5 py-3.5 text-sm text-slate-700">{m.disposition || calDisposition(m.performance, m.values)}</td>
                    <td className="px-5 py-3.5 text-sm text-slate-600">{m.action || <span className="text-slate-300">—</span>}</td>
                    <td className="px-5 py-3.5 text-sm text-slate-700">{m.owner || <span className="text-slate-300">—</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
